// HeroSlider.jsx
'use client';
import { useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectFade, A11y, Pagination } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import Hero from '../hero/hero';

const HeroSlider = ({slides}) => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  return (
      <div className="hero-slider-wrapper">
          <Swiper
              modules={[Autoplay, EffectFade, A11y, Pagination]}
              effect="fade"
              autoplay={{ delay: 6000, disableOnInteraction: false, pauseOnMouseEnter: true }}
              loop
              speed={700}
              pagination={{ el: '.hero-pagination', clickable: true }}
          >
          {slides.map((s, i) => (
            <SwiperSlide key={i}>
              <Hero data={s} />
            </SwiperSlide>
          ))}
        </Swiper>

      {/* Controls row (bottom overlay or just under the hero) */}
      {/* <div className="hero-controls">
        <button ref={prevRef} className="hero-nav-btn hero-nav-btn-prev" aria-label="Previous slide">
          ←
        </button>

        <div className="hero-pagination" aria-label="Hero slide pagination"></div>

        <button ref={nextRef} className="hero-nav-btn hero-nav-btn-next" aria-label="Next slide">
          →
        </button>
      </div> */}

    </div>
  );
}

export default HeroSlider;